// Local dev environment for Mangalam theme
// Usage: npm run start:mangalam  |  ng serve --configuration=mangalam
export const environment = {
  production: false,
  theme: 'society' as 'legacy' | 'society',
  appName: 'SocietyXpert',
  domainUrl: 'https://mangalam.societyxpert.com/',
  localhostUrl: 'http://localhost:4200',
  baseUrl: 'https://mangalam.societyxpert.com/api/public/api',
  storageUrl: 'https://mangalam.societyxpert.com/api/storage/app/',

  // Alternative storageUrl if needed:
  // storageUrl: 'https://app.societyxpert.com/api/storage/app/',
  enquiryFormUrl: 'https://mangalam.societyxpert.com/php',
};
